import { render, staticRenderFns } from "./publishModel.vue?vue&type=template&id=3707eb8a"
import script from "./publishModel.vue?vue&type=script&lang=js"
export * from "./publishModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3707eb8a')) {
      api.createRecord('3707eb8a', component.options)
    } else {
      api.reload('3707eb8a', component.options)
    }
    module.hot.accept("./publishModel.vue?vue&type=template&id=3707eb8a", function () {
      api.rerender('3707eb8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/publishModel.vue"
export default component.exports